var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-bottom"
        },
        [
          _vm.viewData.user
            ? _c("h1", { staticClass: "h2" }, [
                _vm._v(
                  "\n      Instalações de " +
                    _vm._s(_vm.viewData.user.name) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btn-toolbar mb-2 mb-md-0" }, [
            _c(
              "div",
              { staticClass: "btn-toolbar mb-2 mb-md-0" },
              [
                _c(
                  "div",
                  { staticClass: "btn-group mr-2" },
                  [
                    _c(
                      "BaseButtonComponent",
                      {
                        attrs: { variant: "secondary-action" },
                        on: {
                          click: function($event) {
                            return _vm.$bvModal.show("bv-modal-example")
                          }
                        }
                      },
                      [_vm._v("Nova Instalação")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    attrs: { id: "bv-modal-example", size: "lg" },
                    scopedSlots: _vm._u([
                      {
                        key: "modal-title",
                        fn: function() {
                          return [_vm._v("Nova Instalação")]
                        },
                        proxy: true
                      },
                      {
                        key: "modal-footer",
                        fn: function() {
                          return [
                            _c(
                              "BaseButtonComponent",
                              {
                                staticStyle: { float: "left" },
                                attrs: { variant: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.$bvModal.hide("bv-modal-example")
                                  }
                                }
                              },
                              [_vm._v("Fechar")]
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                staticStyle: { float: "right" },
                                attrs: { variant: "primary-action" },
                                on: { click: _vm.save }
                              },
                              [
                                _vm.viewData.saving
                                  ? _c("b-icon", {
                                      attrs: {
                                        icon: "three-dots",
                                        animation: "cylon"
                                      }
                                    })
                                  : _c("span", [_vm._v("Criar Instalação")])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-form",
                      [
                        _c("error-container", {
                          attrs: { errors: _vm.viewData.errors || [] }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Tensão",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          options: _vm.viewData.tensions,
                                          state: _vm.isOk("tension")
                                        },
                                        model: {
                                          value: _vm.state.tension,
                                          callback: function($$v) {
                                            _vm.$set(_vm.state, "tension", $$v)
                                          },
                                          expression: "state.tension"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" }
                                          },
                                          [_vm._v("Selecione uma tensão")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("tension")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Modalidade tarifária",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          options: _vm.viewData.modalities,
                                          state: _vm.isOk("tariffModality")
                                        },
                                        model: {
                                          value: _vm.state.tariffModality,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.state,
                                              "tariffModality",
                                              $$v
                                            )
                                          },
                                          expression: "state.tariffModality"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Selecione uma modalidade tarifária\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        _vm._s(_vm.getError("tariffModality"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Classe",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          options: _vm.viewData.classes,
                                          state: _vm.isOk("class")
                                        },
                                        model: {
                                          value: _vm.state.class,
                                          callback: function($$v) {
                                            _vm.$set(_vm.state, "class", $$v)
                                          },
                                          expression: "state.class"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" }
                                          },
                                          [_vm._v("Selecione uma classe")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("class")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Tipo de ligação",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          options: _vm.viewData.connectionTypes,
                                          state: _vm.isOk("connectionType")
                                        },
                                        model: {
                                          value: _vm.state.connectionType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.state,
                                              "connectionType",
                                              $$v
                                            )
                                          },
                                          expression: "state.connectionType"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Selecione um tipo de ligação\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        _vm._s(_vm.getError("connectionType"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "input-group-1",
                              label: "Número da Instalação",
                              "label-for": "input-1"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Informe o Número da Instalação",
                                state: _vm.isOk("installationNumber")
                              },
                              on: {
                                keypress: function($event) {
                                  return _vm.isNumber($event)
                                }
                              },
                              model: {
                                value: _vm.state.installationNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.state, "installationNumber", $$v)
                                },
                                expression: "state.installationNumber"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.getError("installationNumber")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "input-group-1",
                              label: "Distribuidora",
                              "label-for": "input-1"
                            }
                          },
                          [
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  options: _vm.viewData.powerPlants,
                                  label: "label",
                                  placeholder:
                                    "Pesquise por uma distribuidora..."
                                },
                                on: { search: _vm.search },
                                model: {
                                  value: _vm.state.powerPlantId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.state, "powerPlantId", $$v)
                                  },
                                  expression: "state.powerPlantId"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "no-options" },
                                    slot: "no-options"
                                  },
                                  [_vm._v("Nenhum resultado encontrado.")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.getError("socialNumber")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "input-group-1",
                              label: "CEP",
                              "label-for": "input-1"
                            }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["#####-###"],
                                  expression: "['#####-###']"
                                }
                              ],
                              attrs: {
                                placeholder: "Informe o CEP da instalação",
                                state: _vm.isOk("zipCode")
                              },
                              on: {
                                blur: function($event) {
                                  return _vm.fillCompleteAddress($event)
                                }
                              },
                              model: {
                                value: _vm.state.zipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.state, "zipCode", $$v)
                                },
                                expression: "state.zipCode"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.getError("zipCode")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "input-group-1",
                              label: "Endereço",
                              "label-for": "input-1"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Informe o Endereço da instalação",
                                state: _vm.isOk("address")
                              },
                              model: {
                                value: _vm.state.address,
                                callback: function($$v) {
                                  _vm.$set(_vm.state, "address", $$v)
                                },
                                expression: "state.address"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-form-invalid-feedback", [
                              _vm._v(_vm._s(_vm.getError("address")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Numero",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Informe o Número referente ao endereço da instalação",
                                        state: _vm.isOk("number")
                                      },
                                      on: {
                                        keypress: function($event) {
                                          return _vm.isNumber($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.state.number,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "number", $$v)
                                        },
                                        expression: "state.number"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("number")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Bairro",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Informe o Bairro da instalação",
                                        state: _vm.isOk("district")
                                      },
                                      model: {
                                        value: _vm.state.district,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "district", $$v)
                                        },
                                        expression: "state.district"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("district")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Cidade",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Informe a Cidade da instalação",
                                        state: _vm.isOk("city")
                                      },
                                      model: {
                                        value: _vm.state.city,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "city", $$v)
                                        },
                                        expression: "state.city"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("city")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: "Estado",
                                      "label-for": "input-1"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          options: _vm.viewData.states,
                                          placeholder: "Selecione um Estado",
                                          state: _vm.isOk("state")
                                        },
                                        model: {
                                          value: _vm.state.state,
                                          callback: function($$v) {
                                            _vm.$set(_vm.state, "state", $$v)
                                          },
                                          expression: "state.state"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "", value: "" }
                                          },
                                          [_vm._v("Selecione um estado")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(_vm._s(_vm.getError("state")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      this.viewData.user
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-breadcrumb", {
                    attrs: {
                      items: [
                        {
                          text:
                            "Lista de " +
                            this.getProfileName(this.viewData.user.profile),
                          href: "/#/" + this.viewData.user.profile + "s"
                        },
                        {
                          text: "Edição de " + _vm.viewData.user.name,
                          href: `/#/user/edit/${this.viewData.user.id}/${this.viewData.user.profile}`
                        },
                        {
                          text: "Instalações",
                          href: "#",
                          active: true
                        }
                      ]
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c(
                "table",
                { staticClass: "table b-table table-hover table-bordered" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", [_vm._v("Número")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Distribuidora")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Endereço")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("CEP")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Cidade")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Estado")]),
                      _vm._v(" "),
                      _c("td")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.state.list, function(item) {
                      return _c("tr", { key: item.id }, [
                        _c("td", [_vm._v(_vm._s(item.installationNumber))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.distributor))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(item.address) + ", " + _vm._s(item.number)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatZipCode(item.zipCode)))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.city))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.state))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  to: `/user/${_vm.viewData.userId}/installation/${item.id}/billings/${_vm.viewData.accountId}`,
                                  title: "Faturas",
                                  variant: "secondary-action"
                                }
                              },
                              [_c("b-icon-credit-card")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  to: `/user/${_vm.viewData.userId}/installation/${item.id}/discounts/${_vm.viewData.accountId}`,
                                  title: "Descontos",
                                  variant: "secondary-action"
                                }
                              },
                              [_c("b-icon-cash-stack")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  to: `/installation/edit/${item.id}`,
                                  title: "Editar",
                                  variant: "primary-action"
                                }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "pencil-square",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  title: "Excluir",
                                  variant: "danger"
                                },
                                on: { click: () => _vm.remove(item) }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "trash",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c("b-pagination-nav", {
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }